import { z } from 'zod';

// A mangled id reads as absent, so the page still opens and simply reports nothing.
const absent = (): undefined => {};

export const connectionsSearchSchema = z.object({
  status: z.enum(['success', 'error', 'select_account']).optional(),
  platform: z.string().optional(),
  pending: z.string().optional(),
  message: z.string().optional(),
  // Set by a callback that completed the link and won the organization's platform claim.
  event_id: z.string().max(64).optional().catch(absent),
});

export type ConnectionsSearch = z.infer<typeof connectionsSearchSchema>;
